import { GlassBox } from 'components/glassBox/GlassBox';

import SingleEventStatBorderIcon from 'assets/single-event/icons/stat_border.svg';

type SummaryItemProps = {
  title: string;
  value: string;
  variant?: 'default' | 'staking';
  icon?: string;
  prefix?: string;
};

const containerStyles = {
  default: 'tw-flex tw-flex-col tw-items-center tw-justify-center',
  staking: 'tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center',
};

const glassBoxStyles = {
  default:
    'tw-flex tw-w-[250px] tw-flex-col tw-items-center tw-justify-center tw-gap-[10px] tw-py-[42px] lg:tw-h-[170px] lg:tw-w-[340px] lg:tw-py-[50px]',
  staking: 'tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-[5px] lg:tw-gap-[10px] tw-py-[42px] lg:tw-h-[102px] xl:tw-h-[234px]',
};

const titleStyles = {
  default: 'tw-relative tw-z-10 tw-text-[20px] tw-leading-none tw-text-white',
  staking: 'tw-relative tw-z-10 tw-text-[16px] lg:tw-text-[20px] tw-leading-none tw-text-white',
};

const valueStyles = {
  default:
    'tw-relative tw-z-10 tw-flex tw-items-center tw-gap-[8px] tw-text-[40px] tw-font-bold tw-leading-none tw-text-white',
  staking:
    'tw-relative tw-z-10 tw-flex tw-items-center tw-gap-[8px] tw-text-[30px] lg:tw-text-[32px] xl:tw-text-[40px] tw-font-bold tw-leading-none tw-text-white',
};

const iconStyles = {
  default: 'tw-h-[40px] tw-w-[40px]',
  staking: 'tw-h-[30px] lg:tw-h-[40px] tw-w-[30px] lg:tw-w-[40px]',
};

export const SummaryItem = ({ title, value, variant = 'default', icon, prefix }: SummaryItemProps) => {
  return (
    <div className={containerStyles[variant]}>
      <GlassBox
        gradient="linear-gradient(to bottom right, #2D5EFF 0%, rgba(45, 94, 255, 0.2) 100%)"
        borderWidth="1px"
        className={glassBoxStyles[variant]}
      >
        <span className={titleStyles[variant]}>{title}</span>
        <span className={valueStyles[variant]}>
          {prefix}
          {icon && <img src={icon} alt="" className={iconStyles[variant]} />}
          {value}
        </span>
      </GlassBox>
      <img src={SingleEventStatBorderIcon} alt="stat border" className="tw-w-[160px]" />
    </div>
  );
};
